var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoogleIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "fcd07f56cc2e1379a9d7d7cd3bfae461",
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M8.422,150.97,7.1,155.908l-4.835.1a19.033,19.033,0,0,1-.14-17.742h0l4.3.789,1.885,4.278a11.339,11.339,0,0,0,.107,7.634Z",
    transform: "translate(0 -128.006)",
    fill: "#fbbb00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M279.878,208.176a18.993,18.993,0,0,1-6.773,18.366h0l-5.421-.277-.767-4.79a11.324,11.324,0,0,0,4.872-5.782h-10.16v-7.517Z",
    transform: "translate(-242.21 -192.725)",
    fill: "#518ef8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M59.138,320.261h0a19.006,19.006,0,0,1-28.63-5.813l6.157-5.04a11.3,11.3,0,0,0,16.284,5.786Z",
    transform: "translate(-28.245 -286.445)",
    fill: "#28b446"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M57.627,4.374,51.472,9.413a11.3,11.3,0,0,0-16.657,5.916l-6.19-5.067h0a19,19,0,0,1,29-5.888Z",
    transform: "translate(-26.5)",
    fill: "#f14336"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/google-icon.9ccbda80e8a40a7d822dc241539b52ec.svg";
export { ForwardRef as ReactComponent };